import { T, UI, FONT } from "../constants/tokens";
import Icon from "./Icon";
import LTR from "./LTR";

// "מאיפה הנתונים" — a single honest reference of every live provider the app
// reads from. Product decision: sources no longer clutter each card; they live
// here. Every row is a real, active source in the codebase (zero fabrication),
// and the frequency is the cache interval the code actually uses — the figure
// on screen is never older than that. Audited row by row against the code on
// 2026-09-17; this card used to name er-api as the USD/ILS source and never
// mentioned Yahoo, the Bank of Israel, SEC EDGAR or the translation fallback.
const ROWS = [
  { kind: "מחירי מניות",                                   provider: "Finnhub",          freq: "כל 5 דקות" },
  { kind: "מדדי ארה\"ב · S&P 500 · NASDAQ · Dow · Russell 2000 · VIX", provider: "Yahoo Finance", freq: "תוך-יומי · כל 15 דקות · Russell ו-VIX בעיכוב של 15 דקות" },
  { kind: "מדדי ישראל · ת\"א 35 · ת\"א 125",                  provider: "Yahoo Finance",    freq: "תוך-יומי · כל 15 דקות · בעיכוב של 20 דקות" },
  { kind: "מדדי עולם · DAX · FTSE 100 · Nikkei 225 · Hang Seng", provider: "Yahoo Finance",  freq: "תוך-יומי · כל 15 דקות · בעיכוב של 15 דקות, Nikkei של 30" },
  { kind: "גרף מדד · מכרטיס \"שווקים\"",                       provider: "Yahoo Finance",    freq: "כמו גרף המחיר בעמוד החברה" },
  { kind: "מסחר מורחב · טרום מסחר ואחרי הסגירה, להחזקות",   provider: "Yahoo Finance",    freq: "כל דקה · רק בחלון המסחר המורחב" },
  { kind: "חוזים עתידיים · S&P 500 · Nasdaq",               provider: "Yahoo Finance",    freq: "כל דקה · לפני הפתיחה" },
  { kind: "סגירות יומיות · מניות בתיק, מדדים ו-VIX",         provider: "Yahoo Finance",    freq: "פעם בחצי שעה · שינוי מאז דיווח, שבועי וטווח 52 שבועות" },
  { kind: "תשואת אג\"ח 10Y · ^TNX של CBOE",                  provider: "Yahoo Finance",    freq: "תוך-יומי · כל 15 דקות · FRED כגיבוי" },
  { kind: "מאקרו · ריבית הפד · נפט WTI (ספוט)",              provider: "FRED",             freq: "יומי · לפי סגירה" },
  { kind: "שערי מטבע · USD/ILS, EUR, GBP",                 provider: "Yahoo Finance",    freq: "תוך-יומי · כל 15 דקות" },
  { kind: "שערי מטבע · גיבוי לשלושתם יחד",                provider: "ExchangeRate-API", freq: "יומי" },
  { kind: "ריבית בנק ישראל",                               provider: "Bank of Israel",   freq: "יומי" },
  { kind: "שער יציג דולר/שקל ביום הרכישה · מאז רכישה בשקלים", provider: "Bank of Israel", freq: "לפי תאריך · נשמר במכשיר" },
  { kind: "פרופיל חברה ומדדי יסוד",                        provider: "Finnhub",          freq: "יומי" },
  { kind: "תיאור עסקי · פילוח הכנסות · נתונים פיננסיים · נושאי משרה · עסקאות בעלי עניין", provider: "SEC EDGAR", freq: "יומי · עסקאות בעלי עניין פעמיים ביום" },
  { kind: "חדשות שוק וחברה",                               provider: "Finnhub",          freq: "כל 5 דקות" },
  { kind: "לוח דוחות של החזקות · חגי מסחר",                provider: "Finnhub",          freq: "כל שעה" },
  { kind: "מועדי פרסום · CPI, תעסוקה, תוצר, PCE",            provider: "FRED",             freq: "כל 6 שעות" },
  { kind: "מועדי ישיבות ה-FOMC · 2026–2027",                provider: "Federal Reserve",  freq: "רשימה קבועה · נבדקה 28/09/2026 · עדכון שנתי" },
  { kind: "אירועים גיאופוליטיים · סיווג חדשות Finnhub",     provider: "Google Gemini",    freq: "כל שעה" },
  { kind: "מסמכים רשמיים · סנקציות, בקרות ייצוא, מכסים",   provider: "Federal Register", freq: "יומי" },
  { kind: "סיכומי חדשות · תרגום כותרות ותקצירים · תרגום התיאור העסקי", provider: "Google Gemini", freq: "לפי כתבה · נשמר" },
  { kind: "מה קורה בשוק היום · סיכום כותרות חדשות השוק מ-Finnhub", provider: "Google Gemini", freq: "פעמיים בימי מסחר · כ-16:00 וכ-23:30" },
  { kind: "מודיעין שוק · סוג האירוע ותקציר מחדשות החברות ב-Finnhub", provider: "Google Gemini", freq: "פעמיים ביום · כ-16:00 וכ-23:30" },
  { kind: "דיווחים שוטפים לרשות · 8-K ו-6-K, הסעיפים ונספח 99.1", provider: "SEC EDGAR",  freq: "פעמיים בשעה · 14 הימים האחרונים" },
  { kind: "\"מה דווח\" · סיכום של דיווח שוטף, מהטקסט שלו בלבד", provider: "Google Gemini", freq: "פעם אחת לכל דיווח · נשמר" },
  { kind: "גרף המחיר בעמוד החברה · נרות ומחזור מסחר",       provider: "Yahoo Finance",    freq: "לפי הטווח · נר לכל 5 דקות עד נר חודשי · בעיכוב של עד 15 דקות" },
  { kind: "גרפים · ספריית הגרף (Lightweight Charts™) והגרף המלא", provider: "TradingView",  freq: "חי" },
];

function HeaderCell({ children, align = "right" }) {
  return (
    <div style={{ fontSize: 11, fontWeight: 700, color: UI.text.muted, textAlign: align, textTransform: "uppercase" }}>
      {children}
    </div>
  );
}

// The rows stay in Hebrew in both languages — provider names are Latin either
// way, and the legal text (settingsLegalFull, both languages) points at this
// card by its title, so the title and the intro follow the active language.
const COPY = {
  he: { title: "מאיפה הנתונים", intro: "כל נתון באפליקציה מגיע ממקור חי. כשאין נתון זמין · מוצג מצב ריק, לא המצאה.", cols: ["סוג נתון", "ספק", "תדירות"] },
  en: { title: "Where the data comes from", intro: "Every figure in the app comes from a live source. When none is available, an empty state is shown · never an invented value.", cols: ["Data", "Provider", "Frequency"] },
};

export default function DataSourcesCard({ lang = "he" }) {
  const c = COPY[lang] || COPY.he;
  return (
    <div style={{ background: UI.surface.raised, border: `1px solid ${UI.line.hairline}`, borderRadius: T.radius.xl, boxShadow: UI.shadow.card, padding: "16px 18px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <Icon name="globe" size={18} color={UI.text.secondary}/>
        <span style={{ fontSize: 16, fontWeight: 600, color: UI.text.primary, fontFamily: FONT.heading }}>{c.title}</span>
      </div>
      <div style={{ fontSize: 13, color: UI.text.muted, lineHeight: 1.6, marginBottom: 14 }}>
        {c.intro}
      </div>

      {/* Header */}
      <div style={{
        display: "grid", gridTemplateColumns: "1.5fr 0.95fr 1fr", gap: 8,
        paddingBottom: 8, borderBottom: `1px solid ${UI.line.hairline}`, marginBottom: 4,
      }}>
        <HeaderCell>{c.cols[0]}</HeaderCell>
        <HeaderCell align="left">{c.cols[1]}</HeaderCell>
        <HeaderCell align="left">{c.cols[2]}</HeaderCell>
      </div>

      {/* Rows */}
      {ROWS.map((r, i) => (
        <div key={i} style={{
          display: "grid", gridTemplateColumns: "1.5fr 0.95fr 1fr", gap: 8,
          alignItems: "center", padding: "10px 0",
          borderBottom: i < ROWS.length - 1 ? `1px solid ${UI.line.hairline}` : "none",
        }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: UI.text.primary, lineHeight: 1.4 }}>{r.kind}</div>
          <div style={{ textAlign: "left" }}>
            <LTR style={{ fontFamily: FONT.latin, fontSize: 12.5, fontWeight: 600, color: UI.text.secondary }}>{r.provider}</LTR>
          </div>
          <div style={{ textAlign: "left", fontSize: 12, color: UI.text.muted, lineHeight: 1.4 }}>{r.freq}</div>
        </div>
      ))}
    </div>
  );
}
